import gql from 'graphql-tag'

export default gql`{
  me {
    current_year_annual_leave_remaining
    current_year_annual_leave_days_used
    annual_leave {
      id
      start_date
      start_of_day
      end_date
      end_of_day
      status_id
      status {
        id
        description
      }
      user{
        user_id
        first_name
        last_name
      }
      status_changed_by_user {
        user_id
        first_name
        last_name
      }
      status_change_date
      reason
      date_cancelled
      days_used
    }
    my_staff_annual_leave {
      id
      start_date
      start_of_day
      end_date
      end_of_day
      status_id
      status {
        id
        description
      }
      user{
        user_id
        first_name
        last_name
      }
      status_changed_by_user {
        user_id
        first_name
        last_name
      }
      status_change_date
      reason
      date_cancelled
      days_used
    }
  }
}
`